import React, { useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

function isSuperClaim(claims) {
  return (
    claims?.superAdmin === true ||
    claims?.superadmin === true ||
    String(claims?.role || '').toLowerCase().includes('super')
  );
}

export default function SuperAdminRoute() {
  const { user, claims, loading, refreshClaims } = useAuth();
  const loc = useLocation();

  useEffect(() => {
    if (!loading && user && !isSuperClaim(claims)) {
      refreshClaims({ force: true }).catch(() => {});
    }
  }, [user, claims, loading, refreshClaims]);

  if (loading) {
    return (
      <div className="min-h-[50vh] grid place-items-center text-white/70">
        Checking access…
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;

  return isSuperClaim(claims) ? <Outlet /> : <Navigate to="/no-access" replace />;
}
